import { render } from "./CBHILandingPage.vue?vue&type=template&id=41559ea8&scoped=true"
import script from "./CBHILandingPage.vue?vue&type=script&lang=js"
export * from "./CBHILandingPage.vue?vue&type=script&lang=js"

import "./CBHILandingPage.vue?vue&type=style&index=0&id=41559ea8&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41559ea8"]])

export default __exports__